import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface RolePermissionsState {
    value: any[];
}

const initialState: RolePermissionsState = {
    value: [],
};

const rolePermissionsSlice = createSlice({
  name: 'rolePermissions',
  initialState,
  reducers: {
    setRolePermissions: (state, action: PayloadAction<any[]>) => {
      state.value = action.payload;
    },
  
  },
});

export const { setRolePermissions } = rolePermissionsSlice.actions;
export default rolePermissionsSlice.reducer;
